export const ALEX_PARTICIPANT_ID = 'u-alex'

export type RecipeSummary = {
  id: string
  name: string
  thumbnail: string
  category?: string
  area?: string
}

export type RecipeDetail = RecipeSummary & {
  ingredients: Array<{ name: string; measure: string }>
  steps: string[]
  sourceUrl?: string
}

export type MenuAssignment = {
  date: string
  meal: RecipeSummary
  assignedAt: string
  assignedByUserId: string
}

export type MenuTemplate = {
  id: string
  name: string
  mealsByWeekday: Record<string, RecipeSummary>
  createdAt: string
}

export type RecipeNotes = {
  familyNote: string
  safetyInstruction: string
  updatedAt?: string
  updatedByUserId?: string
}

export type DietaryProfile = {
  allergies: string
  intolerances: string
  dietaryPreferences: string
  textureRequirements: string
  safetyNotes: string
}

export type MealProgress = {
  ingredientKeys: string[]
  stepIndexes: number[]
  updatedAt?: string
  updatedByUserId?: string
}

export type CareMenuData = {
  schemaVersion: 1
  participantId: string
  assignments: Record<string, MenuAssignment>
  templates: MenuTemplate[]
  recipeNotes: Record<string, RecipeNotes>
  dietaryProfile: DietaryProfile
  progress: Record<string, MealProgress>
}


